











































import '../styles/category-tile.css'
import CategoryLink from './CategoryLink.vue'
import Modal from './general/modal/Modal.vue'
import ModalHeader from './general/modal/ModalHeader.vue'
import ModalBody from './general/modal/ModalBody.vue'
import Vue, { PropType } from 'vue'

interface Category {
  id: string
  title: string
  imageUrl?: string
  favorite?: boolean
}

export default Vue.extend({
  data() {
    return {
      showModal: false,
    }
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    categories: {
      type: Array as PropType<Array<Category>>,
      required: true,
    },
    click: {
      type: Function,
      required: true,
    },
  },
  computed: {
    categoriesList(): Array<Category> {
      let categories = this.categories as Array<Category>
      categories = categories.filter((x) => x.title)

      let finalList: Array<Category> = []

      if (categories.length > 3) {
        finalList = categories.slice(0, 2)
      } else {
        finalList = categories
      }

      return finalList
    },
  },
  methods: {
    clickCategory(category: Category) {
      this.click(category)
    },
    openModal() {
      this.showModal = true
      window.scrollTo(0, 0)
    },
  },
  components: { CategoryLink, Modal, ModalHeader, ModalBody },
  name: 'CategoryTile',
})
